import React, { memo } from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';
import { Column, ColumnHeader } from './Column';
import { withTranslate } from '../../../../../shared/i18n/translate';
import themed from '../../../../../../ui/themer/themed';

export interface ITypeProps {
	arrival: boolean;
	role?: 'columnheader' | 'cell';
}

export const StyledType = styled.div<{}, ITheme>`
	color: ${themed(({ color }) => color.text.light)};
	font-size: 16px;
`;

export const Type = withTranslate<ITypeProps>(({ t, arrival }) => (
	<StyledType>
		{t(arrival ? 'flight_list_item_arrival' : 'flight_list_item_departure')}
	</StyledType>
));

export const StyledTypeColumn = styled(({ role = 'columnheader', ...props }) =>
	role === 'columnheader' ? <ColumnHeader {...props} /> : <Column {...props} />,
)`
	max-width: 120px;

	@media (max-width: 720px) {
		display: none;
	}
`;

export const TypeColumn = memo(({ arrival, role }: ITypeProps) => (
	<StyledTypeColumn role={role}>
		<Type arrival={arrival} />
	</StyledTypeColumn>
));
